export default {"src":"/_next/static/media/dogechain.36935650.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};